export default "__VITE_ASSET__lP6KW5j___"